import React from "react";
import { Topbar } from "@components";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import {
  AppleFilled,
  FacebookFilled,
  PlayStoreFilled,
  ViberFilled,
  YoutubeFilled,
  ApkFilled,
  TelegramFilled,
} from "@assets";
import { Space, Divider as AntDivider } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const RootContainer = styled.div`
  min-height: 100vh;
  padding: 24px;
  text-align: center;

  svg {
    cursor: pointer;
  }
`;

export const Divider = styled(AntDivider)`
  /* padding: 0px 30px 12px 30px; */
  .ant-divider-inner-text {
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => props.theme.textColor};
    background: white;
    border-radius: 21px;
    padding: 4px 16px;
  }

  ::before,
  ::after {
    border: 1px solid ${(props) => props.theme.divider};
    border-color: ${(props) => props.theme.divider} !important;
  }
`;

const AppDownload = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { social_links } = useSelector((state) => state.app.settings);

  const goBack = () => {
    navigate(-1);
  };

  const Link = ({ url, children }) => (
    <a href={url} target="_blank" rel="noreferrer noopen">
      {children}
    </a>
  );

  return (
    <>
      <Topbar title={t("home.appDownloadTitle")} goBack={goBack} />
      <RootContainer>
        <Divider>{t("home.appDownloadSubTitle1")}</Divider>
        <Space size={"middle"}>
          <Link url={social_links.fb_link}>
            <FacebookFilled />
          </Link>
          <Link url={social_links.viber_link}>
            <ViberFilled />
          </Link>
          <Link url={social_links.telegram_link}>
            <TelegramFilled />
          </Link>
          <Link url={social_links.youtube_link}>
            <YoutubeFilled />
          </Link>
        </Space>

        <Divider>{t("home.appDownloadSubTitle2")}</Divider>
        <Space direction="vertical" size={"middle"}>
          <Link url={social_links.app_store_link}>
            <AppleFilled />
          </Link>
          <Link url={social_links.play_store_link}>
            <PlayStoreFilled />
          </Link>
          <Link url={social_links.download_link}>
            <ApkFilled />
          </Link>
        </Space>
      </RootContainer>
    </>
  );
};

export default AppDownload;
